@if(draftWithdrawalComment) {
  <div class="withdrawal-draft-comment">
    <span [innerHTML]="draftWithdrawalComment.message"></span>
    <div class="withdrawal-draft-consultant-info">
      <libero-consult-image [imageSrc]="displayPhoto"></libero-consult-image>
      <div class="name">
        {{ draftWithdrawalComment.colaborator.name.titleBefore }}
        {{ draftWithdrawalComment.colaborator.name.firstName }}
        {{ draftWithdrawalComment.colaborator.name.lastName }}
        {{ draftWithdrawalComment.colaborator.name.titleAfter }}
      </div>
    </div>
  </div>
}